// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"60823b6e","963":"6d616511"}[chunkId] + ".chunk.js";
};